import { Box, Typography } from '@mui/material';
import { Restricted, RestrictedProps } from '@procureai/permissions-ui';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export type RestrictedRouteProps = Pick<RestrictedProps, 'needs'>;

// TODO: Implement temporary Forbidden component - to be replaced with UX proposed by design team
export const RestrictedRoute = ({ needs, children }: PropsWithChildren<RestrictedRouteProps>) => {
  const { t } = useTranslation(I18nNamespace.common);
  return (
    <Restricted
      needs={needs}
      fallback={
        <Box
          sx={{
            flex: 1,
            justifyItems: 'center',
            alignContent: 'center',
            height: '100%',
          }}
        >
          <Typography variant="body1" color="error">
            {t('Error.missingPermission')}
          </Typography>
        </Box>
      }
    >
      {children}
    </Restricted>
  );
};
